export default "__VITE_ASSET__CAobG3PQ__"